export default function Banner(props) {
  return (
    <>
      <div className="w-full h-full relative">
        <img src={props.img} className="w-full h-[200px] object-cover" alt="" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-black/50 w-full h-full">
          <div className="flex flex-col items-center justify-center h-full text-white text-3xl font-bold">
            {props.title}
          </div>
        </div>
      </div>
    </>
  );
}
